var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main2"},[_c('editPsw'),_vm._v(" "),_c('div',{staticClass:"login-copyright"},[_vm._v(" © 2018 zhiyun-tech.com All rights reserved.   桂林智神信息技术有限公司 桂ICP备15010724号-1")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74d18b91","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/editPassword.vue
// module id = null
// module chunks = 